import { CameraOutlined, CheckOutlined, DownloadOutlined, DownOutlined, FileSearchOutlined, PlayCircleOutlined, QrcodeOutlined, SearchOutlined } from '@ant-design/icons';
import { Button, Col, Descriptions, Divider, Dropdown, Form, Input, Modal, Popconfirm, Row, Select, Space, Spin, Table, Tag, Tooltip } from 'antd';
import { useEffect, useRef, useState } from "react";
import { useSelector } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { responseStatus } from "../../constants";
import { ContentHeader } from "../../components";
import { menuHelper } from "../../helpers/account";
import { Links } from "../../helpers/Links";
import { dateCommon } from "../../helpers/common";
import { DataSelectBox } from "../../models/selectbox";
import { DotKiemKeTaiSan, TrangThaiDotKiemKe } from "../../models/taisan/DotKiemKeTaiSan";
import { BaoCaoKiemKe, LuuKetQuaKiemKeRequest, TaiSan, TaiSanKiemKe, ThongKeKiemKe, TimKiemTaiSanKiemKeRequest } from "../../models/taisan/TaiSan";
import { layChiTietDotKiemKe, capNhatTrangThaiDotKiemKe } from "../../services/dotKiemKeTaiSan";
import { layDsLoaiTaiSan } from "../../services/danhmuc";
import { 
    layDsTaiSanKiemKe, 
    layTaiSanTheoMaQR, 
    luuKetQuaKiemKe, 
    thongKeKiemKe, 
    layBaoCaoKiemKe, 
    xuatBaoCaoKiemKe,
    xuatExcelBangTongHopKiemKeBoPhan,
    xuatExcelBienBanTongHopKiemKe
} from "../../services/taisan";
import BienBanKiemKeTab from './BienBanKiemKeTab';
import QuetQrCamera from './QuetQrCamera';

const { TextArea } = Input;

const KiemKeTaiSan = () => {
    const navigate = useNavigate();
    const user = useSelector((state: any) => state.auth.currentUser);
    const menu: any = menuHelper.checkMultiPermission([Links.TaiSan.KiemKeAllow]);
    const params = new URLSearchParams(window.location.search);
    const idDotKiemKe = params.get('idDotKiemKe');

    const [loading, setLoading] = useState<boolean>(false);
    const [dotKiemKe, setDotKiemKe] = useState<DotKiemKeTaiSan | null>(null);
    const [thongKe, setThongKe] = useState<ThongKeKiemKe | null>(null);
    const [dsTaiSan, setDsTaiSan] = useState<TaiSanKiemKe[]>([]);
    const [total, setTotal] = useState<number>(0);
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [pageSize, setPageSize] = useState<number>(20);

    // Bộ lọc
    const [tuKhoa, setTuKhoa] = useState<string>("");
    const [idLoaiTaiSan, setIdLoaiTaiSan] = useState<number | undefined>();
    const [trangThaiKiemKe, setTrangThaiKiemKe] = useState<number | undefined>();
    const [tinhTrangSuDung, setTinhTrangSuDung] = useState<number | undefined>();
    const [optionLoaiTaiSan, setOptionLoaiTaiSan] = useState<DataSelectBox[]>([]);

    // QR scan
    const [maQRInput, setMaQRInput] = useState<string>("");
    const qrInputRef = useRef<any>(null);
    const [showCamera, setShowCamera] = useState<boolean>(false);
    const [cameraProcessing, setCameraProcessing] = useState<boolean>(false);

    // Modal kiểm kê
    const [showModal, setShowModal] = useState<boolean>(false);
    const [selectedTaiSan, setSelectedTaiSan] = useState<TaiSanKiemKe | null>(null);
    const [formKiemKe] = Form.useForm();
    const [savingKiemKe, setSavingKiemKe] = useState<boolean>(false);

    // Báo cáo
    const [showBaoCao, setShowBaoCao] = useState<boolean>(false);
    const [dsBaoCao, setDsBaoCao] = useState<BaoCaoKiemKe[]>([]);
    const [loadingBaoCao, setLoadingBaoCao] = useState<boolean>(false);

    const [windowHeight, setWindowHeight] = useState(window.innerHeight);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
            setWindowHeight(window.innerHeight);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const trangThaiKiemKeOptions = [
        { value: 0, label: 'Chưa kiểm kê' },
        { value: 1, label: 'Đã kiểm kê' },
    ];

    const tinhTrangSuDungOptions = [
        { value: 1, label: 'Đang sử dụng' },
        { value: 0, label: 'Không sử dụng' },
    ];

    const phuongThucOptions = [
        { value: 1, label: 'Quét QR (Camera)' },
        { value: 2, label: 'Quét QR (Máy scan)' },
        { value: 3, label: 'Thủ công' },
    ];

    const getTrangThaiKiemKeTag = (trangThai: number, phuongThuc?: number) => {
        if (trangThai === 0 || !trangThai) {
            return <Tag color="default">Chưa kiểm kê</Tag>;
        }
        switch (phuongThuc) {
            case 1:
                return <Tag color="blue">Quét QR (Camera)</Tag>;
            case 2:
                return <Tag color="cyan">Quét QR (Máy scan)</Tag>;
            case 3:
                return <Tag color="green">Thủ công</Tag>;
            default:
                return <Tag color="green">Đã kiểm kê</Tag>;
        }
    };

    const getTinhTrangTag = (tinhTrang?: number) => {
        if (tinhTrang === 1) return <Tag color="green">Đang sử dụng</Tag>;
        if (tinhTrang === 0) return <Tag color="red">Không sử dụng</Tag>;
        return <Tag color="default">-</Tag>;
    };

    const getTrangThaiDotTag = (trangThai: number) => {
        switch (trangThai) {
            case TrangThaiDotKiemKe.KhoiTao:
                return <Tag color="default">Khởi tạo</Tag>;
            case TrangThaiDotKiemKe.ThuHoi:
                return <Tag color="red">Thu hồi</Tag>;
            case TrangThaiDotKiemKe.TrinhPhoCVP:
            case TrangThaiDotKiemKe.TrinhCVP:
            case TrangThaiDotKiemKe.TrinhPhoGiamDoc:
            case TrangThaiDotKiemKe.TrinhGiamDoc:
                return <Tag color="blue">Đang trình duyệt</Tag>;
            case TrangThaiDotKiemKe.PhoCVPTraLai:
            case TrangThaiDotKiemKe.CVPTraLai:
            case TrangThaiDotKiemKe.PhoGiamDocTraLai:
            case TrangThaiDotKiemKe.GiamDocTraLai:
                return <Tag color="orange">Bị trả lại</Tag>;
            case TrangThaiDotKiemKe.PheDuyet:
                return <Tag color="green">Đã duyệt</Tag>;
            case TrangThaiDotKiemKe.DangKiemKe:
                return <Tag color="cyan">Đang kiểm kê</Tag>;
            case TrangThaiDotKiemKe.HoanThanh:
                return <Tag color="purple">Hoàn thành</Tag>;
            case TrangThaiDotKiemKe.DaDong:
                return <Tag color="magenta">Đã đóng</Tag>;
            default:
                return <Tag>Không xác định</Tag>;
        }
    };

    const columns = [
        {
            title: 'STT',
            key: 'stt',
            width: 45,
            align: 'center' as const,
            render: (_: any, __: any, index: number) => (currentPage - 1) * pageSize + index + 1,
            responsive: ['md'] as const,
        },
        {
            title: 'Mã tài sản',
            dataIndex: 'ma',
            key: 'ma',
            width: isMobile ? 90 : 110,
        },        
        {
            title: 'Tên tài sản',
            dataIndex: 'tenTaiSan',
            key: 'tenTaiSan',
            width: isMobile ? undefined : 200,
        },
        {
            title: 'Loại',
            dataIndex: 'loaiTaiSan',
            key: 'loaiTaiSan',
            width: isMobile ? 100 : 150,
            responsive: ['md'] as const,
        },
        {
            title: 'Bộ phận sử dụng',
            dataIndex: 'tenDonVi',
            key: 'tenDonVi',
            width: isMobile ? undefined : 150,
            responsive: ['lg'] as const,
        },
        {
            title: 'Vị trí',
            dataIndex: 'viTriSuDung',
            key: 'viTriSuDung',
            width: 100,
            render: (text: string) => text || '-',
            responsive: ['lg'] as const,
        },
        {
            title: 'KK',
            key: 'trangThaiKiemKe',
            width: 130,
            render: (_: any, record: TaiSanKiemKe) => getTrangThaiKiemKeTag(record.trangThaiKiemKe, record.phuongThucKiemKe),
            responsive: ['md'] as const,
        },
        {
            title: 'Sử dụng',
            key: 'tinhTrangSuDung',
            width: 110,
            render: (_: any, record: TaiSanKiemKe) => record.trangThaiKiemKe > 0 ? getTinhTrangTag(record.tinhTrangSuDung) : '-',
            responsive: ['lg'] as const,
        },
        {
            title: 'Ghi chú',
            dataIndex: 'ghiChuKiemKe',
            key: 'ghiChuKiemKe',
            width: isMobile ? undefined : 150,
            render: (text: string) => text || '-',
            responsive: ['lg'] as const,
        },
        {
            title: 'NKK',
            dataIndex: 'nguoiKiemKe',
            key: 'nguoiKiemKe',
            width: 100,
            render: (text: string) => text || '-',
            responsive: ['lg'] as const,
        },
        {
            title: 'Thao tác',
            key: 'action',
            width: 100,
            align: 'center' as const,
            fixed: 'right' as const,
            render: (_: any, record: TaiSanKiemKe) => (
                <Button
                    type="primary"
                    size="small"
                    onClick={() => handleMoModalKiemKe(record)}
                    disabled={dotKiemKe?.trangThai !== TrangThaiDotKiemKe.DangKiemKe}
                >
                    {record.trangThaiKiemKe > 0 ? 'Cập nhật' : 'Kiểm kê'}
                </Button>
            ),
        },
    ];

    const nam = dotKiemKe?.ngayKetThuc ? new Date(dotKiemKe.ngayKetThuc).getFullYear() : '';
    const ngayKetThuc = dotKiemKe?.ngayKetThuc ? dateCommon.formatDate(dotKiemKe.ngayKetThuc) : '';

    const baoCaoColumns = [
        { title: 'TT', dataIndex: 'stt', key: 'stt', width: 50, align: 'center' as const },
        { title: 'Tên loại TSCĐ, Công cụ dụng cụ', dataIndex: 'tenLoaiTaiSan', key: 'tenLoaiTaiSan', width: 230 },
        { title: `Thực tế đến ngày ${ngayKetThuc}`, dataIndex: 'soLuongKyTruoc', key: 'soLuongKyTruoc', width: 100, align: 'center' as const },
        { title: `Tăng đến hết ngày 31/12/${nam}`, dataIndex: 'soLuongTang', key: 'soLuongTang', width: 90, align: 'center' as const, render: (val: number) => val > 0 ? val : '' },
        { title: `Giảm đến hết ngày 31/12/${nam}`, dataIndex: 'soLuongGiam', key: 'soLuongGiam', width: 90, align: 'center' as const, render: (val: number) => val > 0 ? val : '' },
        { title: `SL thực tế KK ngày 31/12/${nam}`, dataIndex: 'soLuongHienTai', key: 'soLuongHienTai', width: 100, align: 'center' as const },
        { title: 'Mã số (nếu có)', dataIndex: 'danhSachMa', key: 'danhSachMa', width: 200 },
        { title: 'Đang sử dụng', dataIndex: 'dangSuDung', key: 'dangSuDung', width: 100, align: 'center' as const },
        { title: 'Không sử dụng', dataIndex: 'khongSuDung', key: 'khongSuDung', width: 110, align: 'center' as const },
        { title: 'Ghi chú', dataIndex: 'ghiChu', key: 'ghiChu', width: 150 },
    ];

    const loadDotKiemKe = async () => {
        if (!idDotKiemKe) return;
        try {
            const result = await layChiTietDotKiemKe(parseInt(idDotKiemKe));
            setDotKiemKe(result);
        } catch (error: any) {
            toast.error('Lỗi khi tải thông tin đợt kiểm kê: ' + error.message);
            navigate(Links.TaiSan.DotKiemKe);
        }
    };

    const loadThongKe = async () => {
        if (!idDotKiemKe) return;
        try {
            const result = await thongKeKiemKe(parseInt(idDotKiemKe));
            setThongKe(result);
        } catch (error: any) {
            console.error(error);
        }
    };

    const loadDanhSach = async () => {
        if (!idDotKiemKe) return;
        try {
            setLoading(true);
            const result = await layDsTaiSanKiemKe(
                {
                    idDotKiemKe: parseInt(idDotKiemKe),
                    tuKhoa,
                    idLoaiTaiSan,
                    trangThaiKiemKe,
                    tinhTrangSuDung,
                },
                (currentPage - 1) * pageSize,
                pageSize
            );
            setDsTaiSan(result.data);
            setTotal(result.recordsTotal);
        } catch (error: any) {
            toast.error('Lỗi khi tải danh sách tài sản: ' + error.message);
        } finally {
            setLoading(false);
        }
    };

    const loadSelectBoxes = async () => {
        try {
            const loaiTaiSan = await layDsLoaiTaiSan();
            setOptionLoaiTaiSan(loaiTaiSan);
        } catch (error: any) {
            console.error(error);
        }
    };

    const handleTimKiem = () => {
        setCurrentPage(1);
        loadDanhSach();
    };

    // Xử lý chung khi quét được mã QR (dùng cho cả máy scan và camera)
    const xuLyMaQR = async (ma: string, phuongThuc: number) => {
        try {
            const result = await layTaiSanTheoMaQR(ma);
            const taiSan = result as TaiSan | null;
            if (taiSan) {
                const kiemKeItem: TaiSanKiemKe = {
                    id: taiSan.id!,
                    ma: taiSan.ma,
                    maHienThi: taiSan.ma,
                    tenTaiSan: taiSan.tenTaiSan,
                    idLoaiTaiSan: taiSan.idLoaiTaiSan,
                    loaiTaiSan: taiSan.loaiTaiSan || '',
                    tenDonVi: taiSan.tenDonVi,
                    nguoiSuDung: taiSan.nguoiSuDung,
                    viTriSuDung: taiSan.viTriSuDung,
                    trangThai: taiSan.trangThai,
                    maQR: taiSan.maQR,
                    trangThaiKiemKe: 0,
                    phuongThucKiemKe: phuongThuc,
                };
                handleMoModalKiemKe(kiemKeItem, phuongThuc);
                toast.info(`Tìm thấy tài sản: ${taiSan.tenTaiSan}`);
            } else {
                toast.warning('Không tìm thấy tài sản với mã QR: ' + ma);
            }
        } catch (error: any) {
            toast.error('Không tìm thấy tài sản: ' + error.message);
        }
    };

    // Quét QR từ máy scan
    const handleQRScan = async (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            const ma = maQRInput.trim();
            if (!ma) return;

            try {
                await xuLyMaQR(ma, 2); // 2 = QR_SCANNER
            } finally {
                setMaQRInput("");
                setTimeout(() => qrInputRef.current?.focus(), 100);
            }
        }
    };

    // Quét QR từ camera
    const handleCameraScanSuccess = async (decodedText: string) => {
        if (cameraProcessing) return;
        setCameraProcessing(true);
        try {
            await xuLyMaQR(decodedText, 1); // 1 = QR_CAMERA
        } finally {
            setCameraProcessing(false);
        }
    };

    const handleMoModalKiemKe = (record: TaiSanKiemKe, phuongThuc?: number) => {
        setSelectedTaiSan(record);
        formKiemKe.setFieldsValue({
            tinhTrangSuDung: record.tinhTrangSuDung ?? (record.trangThai === 1 ? 1 : undefined),
            ghiChuKiemKe: record.ghiChuKiemKe || '',
            phuongThucKiemKe: phuongThuc || record.phuongThucKiemKe || 3,
        });
        setShowModal(true);
    };

    const handleLuuKiemKe = async () => {
        if (!selectedTaiSan || !idDotKiemKe) return;

        // Bỏ comment bên dưới khi cần bật kiểm tra quyền lưu kiểm kê
        // // Kiểm tra quyền lưu kiểm kê
        // const coQuyen = menu[Links.TaiSan.KiemKeAllow];
        // if (!coQuyen) {
        //     toast.error('Bạn không có quyền lưu kiểm kê tài sản. Vui lòng liên hệ quản trị viên.');
        //     return;
        // }

        // Nếu đợt kiểm kê có chỉ định người phụ trách, kiểm tra người dùng có trong danh sách không
        const idsDSNguoiPhuTrach = dotKiemKe?.idsDSNguoiPhuTrach || [];
        if (idsDSNguoiPhuTrach.length > 0) {
            const idNhanVienHienTai = user?.idNhanVien;
            if (!idNhanVienHienTai || !idsDSNguoiPhuTrach.includes(idNhanVienHienTai)) {
                toast.error('Bạn không nằm trong danh sách người phụ trách đợt kiểm kê này nên không thể lưu kiểm kê tài sản.');
                return;
            }
        }

        try {
            const values = await formKiemKe.validateFields();
            setSavingKiemKe(true);

            const request: LuuKetQuaKiemKeRequest = {
                idDotKiemKe: parseInt(idDotKiemKe),
                idTaiSan: selectedTaiSan.id,
                trangThaiKiemKe: 1,
                phuongThucKiemKe: values.phuongThucKiemKe,
                tinhTrangSuDung: values.tinhTrangSuDung,
                ghiChuKiemKe: values.ghiChuKiemKe,
            };

            const response = await luuKetQuaKiemKe(request);
            if (response.trangThai === responseStatus.thanhCong) {
                toast.success(response.thongBao || 'Lưu kết quả kiểm kê thành công');
                setShowModal(false);
                loadDanhSach();
                loadThongKe();
            } else {
                toast.error(response.thongBao);
            }
        } catch (error: any) {
            toast.error('Lỗi khi lưu kiểm kê: ' + error.message);
        } finally {
            setSavingKiemKe(false);
        }
    };

    const handleBatDauKiemKe = async () => {
        if (!idDotKiemKe) return;
        try {
            await capNhatTrangThaiDotKiemKe(parseInt(idDotKiemKe), TrangThaiDotKiemKe.DangKiemKe);
            toast.success('Bắt đầu kiểm kê thành công');
            loadDotKiemKe();
        } catch (error: any) {
            toast.error('Lỗi: ' + error.message);
        }
    };

    const handleHoanThanhKiemKe = async () => {
        if (!idDotKiemKe) return;
        try {
            await capNhatTrangThaiDotKiemKe(parseInt(idDotKiemKe), TrangThaiDotKiemKe.HoanThanh);
            toast.success('Hoàn thành kiểm kê thành công');
            loadDotKiemKe();
        } catch (error: any) {
            toast.error('Lỗi: ' + error.message);
        }
    };

    const handleXemBaoCao = async () => {
        if (!idDotKiemKe) return;
        try {
            setLoadingBaoCao(true);
            setShowBaoCao(true);
            const result = await layBaoCaoKiemKe(parseInt(idDotKiemKe));
            setDsBaoCao(result);
        } catch (error: any) {
            toast.error('Lỗi khi tải báo cáo: ' + error.message);
        } finally {
            setLoadingBaoCao(false);
        }
    };

    const handleXuatExcel = async () => {
        if (!idDotKiemKe) return;
        try {
            await xuatBaoCaoKiemKe(parseInt(idDotKiemKe));
            toast.success('Xuất báo cáo thành công');
        } catch (error: any) {
            toast.error('Lỗi khi xuất báo cáo: ' + error.message);
        }
    };

    const handleXuatExcelBangTongHopBoPhan = async () => {
        if (!idDotKiemKe) return;
        try {
            await xuatExcelBangTongHopKiemKeBoPhan(parseInt(idDotKiemKe));
            toast.success('Xuất Bảng tổng hợp kiểm kê phòng/ban thành công');
        } catch (error: any) {
            toast.error('Lỗi khi xuất Biểu mẫu 1: ' + error.message);
        }
    };

    const handleXuatExcelBienBanTSCD = async () => {
        if (!idDotKiemKe) return;
        try {
            await xuatExcelBienBanTongHopKiemKe(parseInt(idDotKiemKe), 'TSCD');
            toast.success('Xuất Biên bản tổng hợp kết quả kiểm kê TSCĐ thành công');
        } catch (error: any) {
            toast.error('Lỗi khi xuất Biểu mẫu 2: ' + error.message);
        }
    };

    const handleXuatExcelBienBanCCDC = async () => {
        if (!idDotKiemKe) return;
        try {
            await xuatExcelBienBanTongHopKiemKe(parseInt(idDotKiemKe), 'CCDC');
            toast.success('Xuất Biên bản tổng hợp kết quả kiểm kê CCDC thành công');
        } catch (error: any) {
            toast.error('Lỗi khi xuất Biểu mẫu 3: ' + error.message);
        }
    };

    useEffect(() => {
        if (idDotKiemKe) {
            loadDotKiemKe();
            loadThongKe();
            loadSelectBoxes();
        } else {
            toast.error('Không tìm thấy đợt kiểm kê');
            navigate(Links.TaiSan.DotKiemKe);
        }
    }, [idDotKiemKe]);

    const canManageKiemKe = dotKiemKe && (
        dotKiemKe.idNVKhoiTao === user?.id ||
        !dotKiemKe.idsDSNguoiPhuTrach ||
        dotKiemKe.idsDSNguoiPhuTrach.length === 0 ||
        dotKiemKe.idsDSNguoiPhuTrach.includes(user?.idNhanVien) ||
        dotKiemKe.idsDSNguoiPhuTrach.includes(user?.id)
    );

    useEffect(() => {
        loadDanhSach();
    }, [currentPage, pageSize, idDotKiemKe]);

    if (!dotKiemKe) {
        return <Spin tip="Đang tải..." style={{ width: '100%', marginTop: 100 }} />;
    }

    return (
        <section>
            <ContentHeader title="Kiểm kê tài sản" />

            {/* Thông tin đợt kiểm kê */}
            <Row gutter={16} style={{ marginBottom: 16 }}>
                <Col span={24}>
                    <div className="card">
                        <div className="card-body">
                            <Descriptions
                                title="Thông tin đợt kiểm kê"
                                bordered
                                size="small"
                                column={{ xxl: 4, xl: 4, lg: 2, md: 2, sm: 1, xs: 1 }}
                            >
                                <Descriptions.Item label="Tên đợt">{dotKiemKe.tenDotKiemKe}</Descriptions.Item>
                                <Descriptions.Item label="Mã đợt">{dotKiemKe.maDotKiemKe}</Descriptions.Item>
                                <Descriptions.Item label="Thời gian">
                                    {dotKiemKe.ngayBatDau ? dateCommon.formatDate(dotKiemKe.ngayBatDau) : ''} - {dotKiemKe.ngayKetThuc ? dateCommon.formatDate(dotKiemKe.ngayKetThuc) : ''}
                                </Descriptions.Item>
                                <Descriptions.Item label="Trạng thái">{getTrangThaiDotTag(dotKiemKe.trangThai)}</Descriptions.Item>
                            </Descriptions>

                            {thongKe && (
                                <Row gutter={[8, 8]} style={{ marginTop: 16 }}>
                                    {[
                                        { value: thongKe.tongTaiSan, label: 'Tổng tài sản', bg: '#f5f5f5', color: undefined },
                                        { value: thongKe.daKiemKe, label: 'Đã kiểm kê', bg: '#e6f7ff', color: '#1890ff' },
                                        { value: thongKe.chuaKiemKe, label: 'Chưa kiểm kê', bg: '#fff7e6', color: '#fa8c16' },
                                        { value: thongKe.dangSuDung, label: 'Đang sử dụng', bg: '#f6ffed', color: '#52c41a' },
                                        { value: thongKe.khongSuDung, label: 'Không sử dụng', bg: '#fff1f0', color: '#f5222d' },
                                        {
                                            value: `${thongKe.tongTaiSan > 0 ? Math.round(thongKe.daKiemKe / thongKe.tongTaiSan * 100) : 0}%`,
                                            label: 'Tiến độ', bg: '#f0f5ff', color: '#2f54eb'
                                        },
                                    ].map((item, index) => (
                                        <Col key={index} xs={8} sm={8} md={4} lg={4} xl={4}>
                                            <div style={{
                                                textAlign: 'center',
                                                padding: '8px 4px',
                                                background: item.bg,
                                                borderRadius: 4,
                                                height: '100%'
                                            }}>
                                                <div style={{ fontSize: 18, fontWeight: 'bold', color: item.color }}>
                                                    {item.value}
                                                </div>
                                                <div style={{ fontSize: 12, lineHeight: '1.3' }}>
                                                    {item.label}
                                                </div>
                                            </div>
                                        </Col>
                                    ))}
                                </Row>
                            )}
                        </div>
                    </div>
                </Col>
            </Row>

            {/* Khu vực thao tác nhanh */}
            <Row gutter={16} style={{ marginBottom: 16 }}>
                <Col span={24}>
                    <div className="card">
                        <div className="card-body">
                            <Row gutter={[8, 8]} align="middle">
                                <Col xs={24} sm={12} md={8}>
                                    <Input
                                        ref={qrInputRef}
                                        placeholder={isMobile ? "Quét QR..." : "Quét hoặc nhập mã QR tại đây..."}
                                        prefix={<QrcodeOutlined />}
                                        value={maQRInput}
                                        onChange={(e) => setMaQRInput(e.target.value)}
                                        onKeyDown={handleQRScan}
                                        disabled={dotKiemKe.trangThai !== TrangThaiDotKiemKe.DangKiemKe}
                                        size={isMobile ? "middle" : "large"}
                                    />
                                </Col>
                                <Col xs={24} sm={24} md={16}>
                                    <Space wrap style={{ width: '100%' }}>
                                        {dotKiemKe.trangThai === TrangThaiDotKiemKe.PheDuyet && canManageKiemKe && (
                                            <Popconfirm
                                                title="Bắt đầu kiểm kê sẽ chuyển trạng thái đợt sang Đang kiểm kê. Xác nhận?"
                                                onConfirm={handleBatDauKiemKe}
                                                okText="Xác nhận"
                                                cancelText="Hủy"
                                            >
                                                <Button
                                                    type="primary"
                                                    icon={<PlayCircleOutlined />}
                                                    size="small"
                                                >
                                                    Bắt đầu kiểm kê
                                                </Button>
                                            </Popconfirm>
                                        )}
                                        {dotKiemKe.trangThai === TrangThaiDotKiemKe.DangKiemKe && canManageKiemKe && (
                                            <Popconfirm
                                                title="Xác nhận hoàn thành kiểm kê? Sau khi hoàn thành sẽ không thể cập nhật kết quả kiểm kê nữa."
                                                onConfirm={handleHoanThanhKiemKe}
                                                okText="Hoàn thành"
                                                cancelText="Hủy"
                                            >
                                                <Button
                                                    icon={<CheckOutlined />}
                                                    size="small"
                                                    style={{ background: '#52c41a', borderColor: '#52c41a', color: '#fff' }}
                                                >
                                                    Hoàn thành kiểm kê
                                                </Button>
                                            </Popconfirm>
                                        )}
                                        <Tooltip title="Quét QR bằng camera">
                                            <Button
                                                type="primary"
                                                icon={<CameraOutlined />}
                                                onClick={() => setShowCamera(true)}
                                                disabled={dotKiemKe.trangThai !== TrangThaiDotKiemKe.DangKiemKe}
                                                size="small"
                                            >
                                                Quét QR Camera
                                            </Button>
                                        </Tooltip>
                                        <Tooltip title="Xem báo cáo tổng hợp">
                                            <Button icon={<FileSearchOutlined />} onClick={handleXemBaoCao} size="small">
                                                {!isMobile && 'Báo cáo tổng hợp'}
                                            </Button>
                                        </Tooltip>
                                        <Dropdown
                                            menu={{
                                                items: [
                                                    {
                                                        key: 'bm1',
                                                        label: '1. Bảng tổng hợp kiểm kê phòng/ban',
                                                        icon: <DownloadOutlined />,
                                                        onClick: handleXuatExcelBangTongHopBoPhan,
                                                    },
                                                    {
                                                        key: 'bm2',
                                                        label: '2. Biên bản kiểm kê TSCĐ (toàn đơn vị)',
                                                        icon: <DownloadOutlined />,
                                                        onClick: handleXuatExcelBienBanTSCD,
                                                    },
                                                    {
                                                        key: 'bm3',
                                                        label: '3. Biên bản kiểm kê CCDC (toàn đơn vị)',
                                                        icon: <DownloadOutlined />,
                                                        onClick: handleXuatExcelBienBanCCDC,
                                                    },
                                                    {
                                                        type: 'divider',
                                                    },
                                                    {
                                                        key: 'bm_old',
                                                        label: 'Báo cáo kiểm kê (cũ)',
                                                        icon: <DownloadOutlined />,
                                                        onClick: handleXuatExcel,
                                                    }
                                                ]
                                            }}
                                        >
                                            <Button icon={<DownloadOutlined />} size="small" type="primary" ghost>
                                                {!isMobile ? 'Xuất biểu mẫu Excel' : 'Xuất Excel'} <DownOutlined />
                                            </Button>
                                        </Dropdown>
                                        <Button onClick={() => navigate(Links.TaiSan.DotKiemKe)} size="small">
                                            Quay lại
                                        </Button>
                                    </Space>
                                </Col>
                            </Row>
                        </div>
                    </div>
                </Col>
            </Row>

            {/* Bộ lọc */}
            <Row className="form-group" gutter={[8, 8]}>
                <Col xs={24} sm={12} md={6}>
                    <Input
                        placeholder="Tìm kiếm..."
                        value={tuKhoa}
                        onChange={(e) => setTuKhoa(e.target.value)}
                        onPressEnter={handleTimKiem}
                        prefix={<SearchOutlined />}
                    />
                </Col>
                <Col xs={24} sm={12} md={4}>
                    <Select
                        allowClear
                        placeholder="Loại TS"
                        style={{ width: '100%' }}
                        options={optionLoaiTaiSan}
                        value={idLoaiTaiSan}
                        onChange={(value) => setIdLoaiTaiSan(value)}
                    />
                </Col>
                <Col xs={24} sm={12} md={4}>
                    <Select
                        allowClear
                        placeholder="Trạng thái KK"
                        style={{ width: '100%' }}
                        options={trangThaiKiemKeOptions}
                        value={trangThaiKiemKe}
                        onChange={(value) => setTrangThaiKiemKe(value)}
                    />
                </Col>
                <Col xs={24} sm={12} md={4}>
                    <Select
                        allowClear
                        placeholder="Tình trạng SD"
                        style={{ width: '100%' }}
                        options={tinhTrangSuDungOptions}
                        value={tinhTrangSuDung}
                        onChange={(value) => setTinhTrangSuDung(value)}
                    />
                </Col>
                <Col xs={24} sm={24} md={6}>
                    <Button type="primary" icon={<SearchOutlined />} onClick={handleTimKiem} style={{ width: isMobile ? '100%' : 'auto' }}>
                        Tìm kiếm
                    </Button>
                </Col>
            </Row>

            {/* Bảng tài sản */}
            <Row>
                <Col span={24}>
                    <div className="card">
                        <div className="card-body">
                            <Table
                                columns={columns}
                                dataSource={dsTaiSan}
                                loading={loading}
                                rowKey="id"
                                scroll={{ x: isMobile ? 800 : 1800 }}
                                pagination={{
                                    current: currentPage,
                                    pageSize: pageSize,
                                    total: total,
                                    showSizeChanger: true,
                                    showTotal: (total) => `Tổng số: ${total}`,
                                    onChange: (page, size) => {
                                        setCurrentPage(page);
                                        setPageSize(size);
                                    },
                                }}
                                size={isMobile ? "small" : "middle"}
                            />
                        </div>
                    </div>
                </Col>
            </Row>

            {/* Biên bản kiểm kê */}
            <Row gutter={16} style={{ marginBottom: 16 }}>
                <Col span={24}>
                    <div className="card">
                        <div className="card-body">
                            <BienBanKiemKeTab dotKiemKe={dotKiemKe} />
                        </div>
                    </div>
                </Col>
            </Row>

            {/* Modal kiểm kê */}
            <Modal
                title={selectedTaiSan ? `Kiểm kê tài sản: ${selectedTaiSan.tenTaiSan}` : 'Kiểm kê tài sản'}
                open={showModal}
                onCancel={() => setShowModal(false)}
                onOk={handleLuuKiemKe}
                confirmLoading={savingKiemKe}
                okText="Lưu kiểm kê"
                cancelText="Đóng"
                width={isMobile ? '95%' : 600}
                centered
                style={{
                    top: isMobile ? 0 : 'auto',
                    margin: isMobile ? '8px auto' : 'auto',
                    paddingBottom: 0,
                }}
                styles={{
                    body: {
                        maxHeight: isMobile ? windowHeight - 300 : 600,
                        overflowY: 'auto',
                        paddingBottom: 16,
                    }
                }}
                getContainer={() => document.body}
            >
                {selectedTaiSan && (
                    <>
                        <Descriptions
                            bordered
                            size="small"
                            column={{ xs: 1, sm: 2 }}
                            style={{ marginBottom: 16 }}
                        >
                            <Descriptions.Item label="Mã tài sản">{selectedTaiSan.ma}</Descriptions.Item>
                            <Descriptions.Item label="Tên tài sản" span={isMobile ? 1 : 2}>{selectedTaiSan.tenTaiSan}</Descriptions.Item>
                            <Descriptions.Item label="Loại tài sản">{selectedTaiSan.loaiTaiSan}</Descriptions.Item>
                            <Descriptions.Item label="Vị trí">{selectedTaiSan.viTriSuDung || '-'}</Descriptions.Item>
                            {selectedTaiSan.trangThaiKiemKe > 0 && (
                                <>
                                    <Descriptions.Item label="Trạng thái">{getTrangThaiKiemKeTag(selectedTaiSan.trangThaiKiemKe, selectedTaiSan.phuongThucKiemKe)}</Descriptions.Item>
                                    <Descriptions.Item label="Người kiểm kê">{selectedTaiSan.nguoiKiemKe || '-'}</Descriptions.Item>
                                </>
                            )}
                        </Descriptions>
                        <Divider style={{ margin: '12px 0' }} />
                        <Form form={formKiemKe} layout="vertical">
                            <Form.Item
                                name="phuongThucKiemKe"
                                label="Phương thức kiểm kê"
                                rules={[{ required: true, message: 'Vui lòng chọn phương thức' }]}
                            >
                                <Select options={phuongThucOptions} placeholder="Chọn phương thức" />
                            </Form.Item>
                            <Form.Item
                                name="tinhTrangSuDung"
                                label="Tình trạng sử dụng"
                                rules={[{ required: true, message: 'Vui lòng chọn tình trạng sử dụng' }]}
                            >
                                <Select options={tinhTrangSuDungOptions} placeholder="Chọn tình trạng" />
                            </Form.Item>
                            <Form.Item name="ghiChuKiemKe" label="Ghi chú kiểm kê" style={{ marginBottom: 0 }}>
                                <TextArea rows={3} placeholder="Nhập ghi chú" />
                            </Form.Item>
                        </Form>
                    </>
                )}
            </Modal>

            {/* Modal báo cáo tổng hợp */}
            <Modal
                title="Báo cáo tổng hợp kiểm kê tài sản"
                open={showBaoCao}
                onCancel={() => setShowBaoCao(false)}
                footer={[
                    <Button key="export" type="primary" icon={<DownloadOutlined />} onClick={handleXuatExcel}>
                        Xuất Excel
                    </Button>,
                    <Button key="close" onClick={() => setShowBaoCao(false)}>
                        Đóng
                    </Button>,
                ]}
                width={1200}
            >
                <Table
                    columns={baoCaoColumns}
                    dataSource={dsBaoCao}
                    loading={loadingBaoCao}
                    rowKey="stt"
                    scroll={{ x: 1100 }}
                    pagination={false}
                    size="small"
                />
            </Modal>

            {/* Modal quét QR bằng camera */}
            <Modal
                title="Quét mã QR bằng camera"
                open={showCamera}
                onCancel={() => setShowCamera(false)}
                footer={null}
                width={600}
                destroyOnClose
            >
                <QuetQrCamera
                    visible={showCamera}
                    onScanSuccess={handleCameraScanSuccess}
                    onClose={() => setShowCamera(false)}
                    processing={cameraProcessing}
                />
            </Modal>
        </section>
    );
};

export default KiemKeTaiSan;
